import script from "./ScrollPane.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollPane.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollPane.vue?vue&type=style&index=0&id=1f457bfa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f457bfa"]])

export default __exports__